import { render, staticRenderFns } from "./SelectCommuneDialog.vue?vue&type=template&id=5c76c067&scoped=true"
import script from "./SelectCommuneDialog.vue?vue&type=script&lang=js"
export * from "./SelectCommuneDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76c067",
  null
  
)

export default component.exports